import React, { useState } from "react";
import _ from "lodash";
import CustomModalBody from "components/Modal/body";
import CustomModalFooter from "components/Modal/footer";
import { Input, Form, FormGroup, Label, Row, Col } from "reactstrap";

export default function FilterForm({ onSubmit, onChangeHOC, handleState }) {
	const [logID, setLogID] = useState("");
	const [orderID, setOrderID] = useState("");
	const [actions, setActions] = useState("");
	const [ipAddress, setIP] = useState("");
	const [timestamp, setTime] = useState(null);

	const handleClear = () => {
		setTime("");
		setLogID("");
		setOrderID("");
		setActions("");
		setIP("");
	};

	const generateQuery = () => {
		let queryString = "";

		if (logID) {
			queryString += `&log_id=${encodeURIComponent(logID)}`;
		}
		if (orderID) {
			queryString += `&source_id=${encodeURIComponent(orderID.trim())}`;
		}
		if (actions) {
			queryString += `&actions=${encodeURIComponent(actions)}`;
		}
		if (ipAddress) {
			queryString += `&ip_address=${encodeURIComponent(ipAddress)}`;
		}
		if (timestamp) {
			queryString += `&timestamp=${encodeURIComponent(timestamp)}`;
		}

		return queryString;
	};

	return (
		<>
			<CustomModalBody>
				<Form id="billing-filter-form">
					<Row>
						<Col lg={3}>
							<FormGroup>
								<Label for="timestamp">Timestamp </Label>
								<Input
									type="datetime-local"
									placeholder="Enter Timestamp"
									name="timestamp"
									id="timestamp"
									value={timestamp}
									onChange={(e) => {
										setTime(e.target.value);
									}}
								/>
							</FormGroup>
						</Col>
						<Col lg={3}>
							<FormGroup>
								<Label for="logID">Log ID </Label>
								<Input
									placeholder="Enter Log ID"
									name="logID"
									id="logID"
									value={logID}
									onChange={(e) => {
										setLogID(e.target.value);
									}}
								/>
							</FormGroup>
						</Col>
						<Col lg={3}>
							<FormGroup>
								<Label for="orderID">Order ID </Label>
								<Input
									placeholder="Enter Order ID"
									name="orderID"
									id="orderID"
									value={orderID}
									onChange={(e) => {
										setOrderID(e.target.value);
									}}
								/>
							</FormGroup>
						</Col>
						<Col lg={3}>
							<FormGroup>
								<Label for="actions">Actions </Label>
								<Input
									placeholder="Enter Actions"
									name="actions"
									id="actions"
									value={actions}
									onChange={(e) => {
										setActions(e.target.value);
									}}
								/>
							</FormGroup>
						</Col>
						<Col lg={3}>
							<FormGroup>
								<Label for="ipAddress">IP Address </Label>
								<Input
									placeholder="Enter IP Address"
									name="ipAddress"
									id="ipAddress"
									value={ipAddress}
									onChange={(e) => {
										setIP(e.target.value);
									}}
								/>
							</FormGroup>
						</Col>
					</Row>
				</Form>
			</CustomModalBody>
			<CustomModalFooter
				rightButton={[
					{
						color: "danger",
						outline: true,
						content: "Clear All",
						onClick: () => handleClear(),
					},
					{
						color: "primary",
						content: "Submit",
						onClick: () => {
							const queryString = generateQuery();
							onSubmit(queryString);
							handleState({ filterQuery: queryString });
							onChangeHOC("showFilterModal", false);
							onChangeHOC("logPages", 1);
						},
					},
				]}
			/>
		</>
	);
}
